import {DataFetcher} from '@aboutyou/data-fetcher';
import {useCurrentPageType} from '@aboutyou/router';
import React from 'react';
import {useIsQuickView} from '../../ArticleDetail/QuickView/useIsQuickView';
import {useFooterDynamicSection} from '../../ArticleDetail/useGetProductBulkSection';
import {
  FooterDynamicView,
  FooterDynamicViewProps,
} from '../FooterDynamic/FooterDynamicView';

export const FooterDynamicADP: React.FC<FooterDynamicViewProps> = props => {
  const pageType = useCurrentPageType();
  const isQuickView = useIsQuickView();

  // On QuickView, we do not want to render the footer dynamic section
  // because QuickView has canonical link to the normal article detail page
  // Thus, we do not have to render the footer dynamic section
  // For this reason we also do not include the `dynamicFooterSection` in the GetMinimalProductBulk response
  if (isQuickView) {
    return null;
  }

  if (pageType !== 'articleDetail') {
    return null;
  }

  return <FooterDynamicFetcher {...props} />;
};

const FooterDynamicFetcher: React.FC<FooterDynamicViewProps> = props => {
  return (
    <DataFetcher
      request={useFooterDynamicSection()}
      Error={() => null}
      Loading={undefined}
      View={data => <FooterDynamicView footer={data} />}
      viewProps={props}
    />
  );
};
